import type { Dispatch } from 'react';
import { createContext, useContext } from 'react';

import type {
  SignUpAction,
  SignUpData,
} from 'src/modules/signUp/components/Professional/types';

type ProfessionalSignUpContext = {
  user: SignUpData;
  userDispatch: Dispatch<SignUpAction>;
};

const defaultValue: ProfessionalSignUpContext = {
  user: {},
  userDispatch: () => null,
};

const context = createContext(defaultValue);
const { Provider } = context;

const useProfessionalSignUp = (): ProfessionalSignUpContext =>
  useContext(context);

export {
  ProfessionalSignUpContext,
  Provider,
  defaultValue,
  useProfessionalSignUp,
};
